import { AbstractValidatedClass, Joi, ValidatedClass, constraint } from '@verclam/form-validator';

type EnrollmentFormArgs = {
	code: string;
};

@ValidatedClass()
class EnrollmentFormData extends AbstractValidatedClass<EnrollmentFormArgs> {
	@constraint(Joi.string().pattern(/^\d{6}$/), () => 'Le code doit comporter 6 chiffres')
	public readonly code: string;

	constructor(data: EnrollmentFormArgs) {
		super(data);
		this.code = data.code;
		Object.freeze(this);
	}

	static createEmpty(): EnrollmentFormData {
		return new EnrollmentFormData({ code: '' });
	}

	setCode(code: string): this {
		return this.cloneWith({ code } as Partial<EnrollmentFormArgs>);
	}
}

export default EnrollmentFormData;
